import React from 'react';
import { cn } from '@/lib/utils';
import { isRtlText } from '@/lib/text-direction';

interface RichTextDisplayProps {
  content: string;
  className?: string;
}

export function RichTextDisplay({ content, className }: RichTextDisplayProps) {
  // If content is empty or just whitespace, show placeholder
  if (!content || content.trim() === '') {
    return (
      <div className={cn("text-muted-foreground italic", className)}>
        No content available
      </div>
    );
  }

  // Detect RTL text
  const isRtl = isRtlText(content);
  const direction = isRtl ? 'rtl' : 'ltr';

  return (
    <div 
      className={cn(
        "rich-text-content text-foreground leading-relaxed",
        className
      )}
      dir={direction}
      dangerouslySetInnerHTML={{ __html: content }}
      style={{
        // Match ReactQuill's styling
        fontFamily: 'inherit',
        fontSize: '14px',
        lineHeight: '1.5',
        textAlign: isRtl ? 'right' : 'left',
      }}
    />
  );
}
